// extracted by mini-css-extract-plugin
export default {"wrap":"tL-z","fullWidth":"uL-z","hideOnDesktop":"vL-z","content":"wL-z","hasOpenedNav":"xL-z","crumbsList":"yL-z","dropdownsWrap":"zL-z"};